module.exports = __webpack_public_path__ + "img/2-3.d1a0b462.png";